import { render } from "./Banners.vue?vue&type=template&id=e78ea1f4"
import script from "./Banners.vue?vue&type=script&lang=js"
export * from "./Banners.vue?vue&type=script&lang=js"

import "./Banners.vue?vue&type=style&index=0&id=e78ea1f4&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__